import styled from 'styled-components'

export const Nav = styled.nav`
  display: flex;
  height: 90px;
  background-color: white;
  position: relative;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.21);
  ${({ sidebarState, globalNavState }) =>
    !sidebarState || globalNavState ? 'z-index: 56;' : 'z-index: initial;'}
  ul {
    overflow-x: hidden;
    display: flex;
    height: 100%;
    align-items: center;
    background-color: white;
    margin-right: 14px;
    .close {
      display: none;
    }
    li.cta {
      > div > button {
        min-width: 150px;
        height: 50px;
        border-radius: 27px;
        @media only screen and (max-width: ${({ theme }) =>
            theme.breakpoints.nav}px) {
          min-width: 180px !important;
          height: 60px;
          border-radius: 33px;
        }
      }
      ${({ alwaysShowCTA }) =>
        alwaysShowCTA ? 'display: block; margin-left: 28px;' : 'display: none;'}
    }

    @media only screen and (max-width: ${({ theme }) =>
        theme.breakpoints.nav}px) {
      margin-right: 0;
      overflow-y: auto;
      li.cta {
        display: block;
        margin-bottom: 20px;
        margin-left: -2px;
      }
      z-index: 55;
      height: 100%;
      width: 419px;
      position: fixed;
      right: -470px;
      top: 0;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 40px;
      transition: 300ms ease all 0.05s;
      &.active {
        right: 0;
      }
      .close {
        cursor: pointer;
        padding: 12px;
        transition: 300ms ease all;
        margin-left: -12px;
        display: block;
        &:hover {
          fill: ${({ theme }) => theme.colors.active1};
        }
      }
      > * {
        margin-bottom: 40px;
      }
      @media ${(props) => props.theme.breakpoints.mobile} {
        width: 90%;
        right: -110%;
      }
    }
  }
`

export const GlobalDropdown = styled.div`
  position: fixed;
  top: 90px;
  transition: top 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
  left: 0;
  opacity: 1;
  box-sizing: border-box;
  ${({ clickIndex }) => clickIndex && 'opacity: 0;'}
  ${({ sidebarState }) => sidebarState && 'opacity: 0;'}
  opacity: ${typeof window === 'undefined' && '0'};
  @media only screen and (min-width: 1082px) {
    ${({ globalNavState, position }) =>
      globalNavState ? `top: 91px` : `top: ${-position - 30}px`};
    width: 100%;
  }
  padding: 0 32px;
  @media only screen and (max-width: 1082px) {
    height: calc(100% - 90px);

    width: 70%;
    max-width: 520px;
    overflow-y: scroll;
    ${({ globalNavState }) =>
      globalNavState ? `top: 91px` : `top: calc(-100% - 90px)`};
  }

  @media only screen and (max-width: 770px) {
    padding: 0 18px;
  }

  @media only screen and (max-width: 500px) {
    padding: 0 12px;
    width: 100%;
  }

  z-index: 50;
  background-color: #f9faff;
  box-shadow: 0 10px 7px 2px rgba(92, 92, 92, 0.5);
  .global-nav-triangle {
    position: absolute;
    top: -19px;
    left: 30px;
  }
`

export const GlobalTop = styled.div`
  a > img {
    filter: saturate(0.7);
    padding-left: 8px;
    @media only screen and (max-width: 1082px) {
      padding-left: 4px;
    }
  }

  > div {
    position: absolute;
    right: 0;
    top: 0;
    display: inline-flex;
    padding: 4px 8px;
    > div {
      cursor: pointer;
      svg {
        transition: fill 0.3s ease;
      }
      &:hover {
        svg {
          fill: ${({ theme }) => theme.colors.active1};
        }
      }
    }
    > a {
      @media only screen and (max-width: 656px) {
        display: none;
      }
      color: #949494;

      margin-right: 30px;
      transition: color 0.3s ease;
      font-size: 14px;
      vertical-align: middle;
      text-transform: uppercase;
      padding-top: 2px;
      &:hover {
        color: ${({ theme }) => theme.colors.active1};
      }
    }
  }
  margin: 24px 0;
  position: relative;
  max-width: 1500px;
  width: 100%;
`

export const GlobalInner = styled.div`
  width: 100%;
  max-width: 1500px;
  display: flex;
  height: 100%;
  box-sizing: border-box;
  margin: 4px 0;
  align-items: flex-start;

  @media only screen and (max-width: 1082px) {
    display: block;
  }
`

export const GlobalItem = styled.div`
  img {
    max-width: ${({ big }) => (big ? '510.14px' : '245.85px')};
    max-height: 340px;
    height: 100%;
    width: 100%;
  }
  padding: 0 0 2rem;
  margin: 0px 0.4%;
  border-radius: 6px;
  @media only screen and (max-width: 1082px) {
    width: ${({ big }) => (big ? '100%' : 'calc(50% - 5px)')};
    float: ${({ float }) => (float ? float : '')};
    margin: 0;
  }
  a {
    text-decoration: none;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    color: #262626;
    margin: 12px 3px 0;
    transition: color 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .global-item {
    transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    border-radius: 10px;
  }

  .fade {
    transition: opacity ease 1s;
    opacity: ${({ globalNavState }) => (globalNavState ? '1' : '0')};
  }

  &:hover {
    p {
      color: ${({ theme }) => theme.colors.active1};
    }
    .global-item {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),
        0 10px 10px rgba(0, 0, 0, 0.22);
    }
  }
`

export const OuterNav = styled.div`
  margin: 0 auto;
`

export const BackDrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 49;
  display: ${(props) => (props.backDropState ? `block` : `none`)};
  transition: 400ms ease all;
  @media ${({ theme }) => theme.breakpoints.tablet} {
    height: ${({ height }) => `${height}px`};
    top: 0;
    left: 0;
  }
`

export const MenuItemWrapper = styled.li`
  margin-left: 28px;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.nav}px) {
    margin-left: 0;
  }
  .active {
    transform: rotate(180deg);
    transform-origin: 50% 50%;
  }
  .down {
    transition: 300ms ease all;
  }
  svg {
    margin: 5px 0px 1px 10px;
  }
`

export const CloseWrapper = styled.span`
  height: 17px;
  width: 17px;
  margin: 28px 0 40px;
`
